/**

 * Elimina todas las propiedades del objeto
 * @param {Object} obj - El objeto a limpiar
 */
export function clearObject(obj) {
  Object.keys(obj).forEach(key => {
    delete obj[key];
  });
}
